import axios, {AxiosRequestConfig} from "axios";

class ApiLokalni {
    private url: string;
    private bearer: string; // Jako wartość w Header {Authorization : bearer, ....}

    constructor(token: string) {
        this.bearer = `Bearer ${token}`;
        this.url = `${window.location.protocol}//${window.location.host}`
            .replace(/:3000/i, ':8080');
    }

    public getUrl(): string {
        return this.url;
    }

    protected getBearer(): string {
        return this.bearer;
    }

    private withAuthConfig<D = any>(config?: AxiosRequestConfig<D>): AxiosRequestConfig<D> {
        return {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...config?.headers,
                'Authorization': this.getBearer(),
            },
        };
    }

    protected async get<T = any, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<T> {
        const response = await axios.get<T>(url, this.withAuthConfig(config));
        return response.data;
    }

    protected async post<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T> {
        const response = await axios.post<T>(url, data, this.withAuthConfig(config));
        return response.data;
    }

    protected async put<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T> {
        const response = await axios.put<T>(url, data, this.withAuthConfig(config));
        return response.data;
    }

    protected async patch<T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T> {
        const response = await axios.patch<T>(url, data, this.withAuthConfig(config));
        return response.data;
    }
}


export default ApiLokalni;